import { Component } from '@angular/core';

@Component({
	selector: 'app-migration-layout',
	templateUrl: './migration-layout.component.html',
	styleUrls: ['./migration-layout.component.scss'],
})
export class MigrationLayoutComponent {}
